//引入axios和querystring
import Bowser from "bowser";
import axios from 'axios';
const querystring = require('qs');
//引用antd的组件
import { message } from "antd";

/* 声网sdk start */
// import AgoraRTC from 'agora-rtc-sdk';
// const client = AgoraRTC.createClient({
//     mode: 'live',
//     codec: "h264"
// });
// //设置日志级别为 WARNING 级别
// // AgoraRTC.Logger.setLogLevel(AgoraRTC.Logger.WARNING);
// //开启日志自动上传
// AgoraRTC.Logger.enableLogUpload();
// // 声网appId
// const agoraAppId = "1019f267803a46ce847079fef64b4cd3";
const AgoraRTC = {};
const client = {};
/* 声网sdk end */

//json对象copy
const assign = (obj) => {
    return JSON.parse(JSON.stringify(obj))
}

//反解析序列化对象，$.param和sirialize()类似的数据
const unparam = (str) => {
    let dataObj = {};
    if (str !== "") {
        let src = str.indexOf("?") === 0 ? str.substring(1, str.length) : str;
        let arr = src.split('&');
        for (let i = 0; i < arr.length; i++) {
            let arr2 = arr[i].split('=');
            dataObj[arr2[0]] = decodeURIComponent(arr2[1]);
        }
    }
    return dataObj;
};

//ajax封装
/*
ajax({
    url: "/test",
    method: "get",
    data: {}
}).then(res=> {
}).catch(e => {
})
*/

// axios封装
const ajax = (option) => {
    //获取页面参数
    const queryString = unparam(window.location.search);
    let ajaxUrl = option.url;
    let ajaxMethod = option.method ? option.method.toLowerCase() : "get";
    let ajaxData = null;
    if (ajaxMethod === "get") {
        ajaxData = {
            params: option.data || {}
        }
    } else {
        if (option.contentType) {
            ajaxData = {
                data: option.data || {}
            }
        } else {
            ajaxData = {
                data: querystring.stringify(option.data || {})
            }
        }

    }
    return new Promise(function (resolve, reject) {
        axios({
            url: ajaxUrl,
            type: 'json',
            method: ajaxMethod,
            headers: {
                "content-type": option.contentType || "application/x-www-form-urlencoded",
                // "JSESSIONID": localStorage.sessionId || ""
                "JSESSIONID": getTokenById(queryString.accountId || "admin") || "",
                "deviceType": "PC",
                "lang": queryString.lang || 'zh_cn',
            },
            baseURL: option.baseURL ? option.baseURL : "/oivi",
            ...ajaxData
        }).then((res) => {
            if (res.status === 200) {
                if (res.data.status == "200") {
                    resolve(res.data);
                } else {
                    reject(res.data);
                }
            } else {
                console.log("fail: ", res);
            }
        }).catch(function (err) {
            console.log("error: ", err);
            reject(err);
        });
    })
}

const ajaxManage = (option) => {
    return ajax({
        baseURL: "/console/bff",
        ...option
    })
}

// 声网接口初始化并加入房间
function initVideoAndJoinChannel(option) {
    //初始化 Client 对象
    client.init(agoraAppId, () => {
        console.log("AgoraRTC client initialized");
        //加入频道
        client.join(option.channelKey, option.channelName, 0, uid => {
            console.log("User " + uid + " join channel successfully");
            //创建音视频流
            let localStream = AgoraRTC.createStream({
                streamID: uid,
                audio: true,
                video: true,
                screen: false
            });
            //初始化音视频流
            localStream.init(() => {
                console.log("getUserMedia successfully");
                localStream.play('live-pusher');
                //发布本地音视频流
                client.publish(localStream, err => {
                    console.log("Publish local stream error: " + err);
                });
                //发布本地音视频流成功的回调
                // client.on('stream-published', evt => {
                //     console.log("Publish local stream successfully");
                // setInterval(() => {
                //     client.getTransportStats(stats => {
                //         console.log("stats: ", stats);
                //     })
                //     client.getLocalVideoStats(localVideoStats => {
                //         console.log("localVideoStats SendBitrate: ", localVideoStats[uid].SendBitrate);
                //     })
                // }, 1000)
                //     typeof option.success === "function" && option.success(evt);
                // });
                // client.on('stream-added', function (evt) {
                //     var stream = evt.stream;
                //     console.log("New stream added: " + stream.getId());
                //     client.subscribe(stream, function (err) {
                //         console.log("Subscribe stream failed", err);
                //     });
                // })
                // client.on('stream-subscribed', function (evt) {
                //     var remoteStream = evt.stream;
                //     console.log("Subscribe remote stream successfully: " + remoteStream.getId());
                //     remoteStream.play('agora_remote');
                // })
            }, err => {
                console.log("getUserMedia failed", err, typeof err);
                typeof option.fail === "function" && option.fail(err);
                //关闭流
                localStream.close();
            });
        }, err => {
            console.log("Join channel failed", err);
        });
        client.on("error", function (err) {
            console.log("Got error msg:", err, err.reason);
        });
        client.on("exception", function (evt) {
            console.log(evt.code, evt.msg, evt.uid);
            showExceptionTips(evt.code);
        })
    }, err => {
        console.log("AgoraRTC client init failed", err);
    });
}

//展示声网sdk，exception事件提示消息
function showExceptionTips(code) {
    switch (code) {
        case 1001:
            message.error("视频采集帧率过低");
            break;
        case 1002:
            message.error("视频发送帧率过低");
            break;
        case 1003:
            message.error("视频发送码率过低");
            break;
        case 1005:
            message.error("接收视频解码失败");
            break;
        case 2001:
            message.error("发送音量过低");
            break;
        case 2002:
            message.error("接收音量过低");
            break;
        case 2003:
            message.error("音频发送码率过低");
            break;
        case 2005:
            message.error("接收音频解码失败");
            break;
    }
}

// 时间倒计时，time格式(string)：hh:mm:ss
function countTimeDown(time, callback) {
    time = "00:" + createTimeStr(time);
    const timer = setInterval(() => {
        var timeArray = time.split(":");
        var hour = Number(timeArray[0]);
        var minute = Number(timeArray[1]);
        var second = Number(timeArray[2]);
        if (second == 0) {
            second = 59;
            minute--;
        } else {
            second--;
        }
        if (minute == 0 && hour != 0) {
            minute = 59;
            hour--;
        }
        if (hour == 0 && minute == 0 && second == 0) {
            typeof callback === "function" && callback();
            clearInterval(timer);
        }
        time = _completeDate(hour) + ":" + _completeDate(minute) + ":" + _completeDate(second);
        typeof callback === "function" && callback(time);
    }, 1000)
    return timer;
}

// 数字倒数，num格式(number)：60
function countNumDown(num, callback) {
    const timer = setInterval(() => {
        if (num == 0) {
            typeof callback === "function" && callback();
            clearInterval(timer);
        } else {
            num--;
            typeof callback === "function" && callback(num);
        }
    }, 1000)
    return timer;
}

//计时方法，time格式(string)：hh:mm:ss
function countUp(time, callback) {
    const timer = setInterval(() => {
        var timeArray = time.split(":");
        var hour = Number(timeArray[0]);
        var minute = Number(timeArray[1]);
        var second = Number(timeArray[2]);
        second++;
        if (second > 59) {
            second = 0;
            minute++;
        }
        if (minute > 59) {
            minute = 0;
            hour++;
        }
        if (hour >= 24) {
            clearInterval(timer);
        }
        time = _completeDate(hour) + ":" + _completeDate(minute) + ":" + _completeDate(second);
        typeof callback === "function" && callback(time);
    }, 1000)
    return timer;
}

//日期时间补全，num格式(number)：3
function _completeDate(num) {
    if (num < 10) {
        return "0" + num;
    }
    return "" + num;
}

//生成倒计时间，分钟数minute格式(数字字符串或者数字)：3
const createTimeStr = function (second) {
    second = parseInt(second);
    if (isNaN(second)) {
        return "--:--";
    }
    const minute = parseInt(second / 60);
    second = second % 60;
    const hour = parseInt(minute / 60);
    if (hour > 0) {
        return _completeDate(hour) + ":" + _completeDate(minute - 60 * hour) + ":" + _completeDate(second);
    } else {
        return _completeDate(minute) + ":" + _completeDate(second);
    }
}

//颜色转换16进制转rgba
const hex2Rgba = function (hex, opacity) {
    if (!hex) return hex || "#e81118";
    return "rgba(" + parseInt("0x" + hex.slice(1, 3)) + "," + parseInt("0x" + hex.slice(3, 5)) + "," + parseInt("0x" + hex.slice(5, 7)) + "," + (opacity || "1") + ")";
}

/* 国际化 */
import React from "react";
const I18nContext = React.createContext();

// 根据accountId存储和获取token
function getTokenById(id){
    let tokenList = sessionStorage.sessionIdList ? JSON.parse(sessionStorage.sessionIdList) : {};
    return tokenList[id];
}

function setTokenById(id, token){
    let tokenList = sessionStorage.sessionIdList ? JSON.parse(sessionStorage.sessionIdList) : {};
    tokenList[id] = token;
    sessionStorage.sessionIdList = JSON.stringify(tokenList);
}

// trtc 支持的浏览器
const browser = Bowser.getParser(window.navigator.userAgent);
let isValidBrowser = browser.satisfies({
    macos: {
        safari: ">11.1"
    },
    chrome: ">52.1"
});
// 去除包壳浏览器
if(isValidBrowser){
    const agent = navigator.userAgent.toLowerCase();
    // 遨游   qq   搜狗
    if( agent.indexOf( "maxthon" ) > 0 || agent.indexOf( "qqbrowser" ) > 0  ||
        agent.indexOf( "se 2.x" )> 0 ){
        isValidBrowser = false;
    }
    // 截止到2016-3-15，测试360-6、7、8版本通过
    // 可以判断出360极速，但是兼容模式没法判断
    // 360 浏览器判断，偏门 ,没有准确的判断方法
    // if((window.navigator.mimeTypes[40] || !window.navigator.mimeTypes.length)){
    //     isValidBrowser = false;
    // }
    // 校验360
    if(/QQBrowser/.test(navigator.userAgent)){
        isValidBrowser = false;
    }
}

// 报告颜色表
const chatColor = {
    '#E3B88B': ['#1C1C1D', '#5B5B5B', '#91807B', '#A79995', '#E3B88B', '#EBCDAD', '#F1DBC5', '#FAF1E8'],
    '#00C3D5': ['#FFAD5A', '#3CCC6B', '#00C3D5', '#B2EDF2', '#FFD6AC', '#FFEF85', '#FFE00C', '#76DB97', '#AC94FE', '#BF7CF0'],
    '#F0CD46': ['#F0CD46', '#8ACF41', '#B9E28D', '#B4CEEC', '#6B9ED9', '#2D76C9', '#FFE00C', '#76DB97', '#AC94FE', '#BF7CF0'],
    '#55B4E2': ['#FFAD5A', '#3CCC6B', '#55B4E2', '#CBE8F6', '#FFD6AC', '#FFEF85', '#FFE00C', '#76DB97', '#AC94FE', '#BF7CF0'],
    '#7555B0': ['#7555B0', '#D2A3F4', '#ECD7FB', '#B4CEEC', '#D2E1F3', '#FFEF85', '#FFE00C', '#FFAC64', '#FF7C64', '#D4655F'],
    '#C52B22': ['#C52B22', '#FF7C64', '#FFAC64', '#FFD564', '#FFEF85', '#8ACF41', '#B4CEEC', '#6B9ED9', '#AC94FE', '#BF7CF0'],
    '#8ECD41': ['#8ACF41', '#B9E28D', '#B4CEEC', '#6B9ED9', '#2D76C9', '#FFE00C', '#FFD564', '#FFAC64', '#FF7C64', '#D4655F'],
    '#3D6AE8': ['#3D6AE8', '#6B9ED9', '#B4CEEC', '#FFEF85', '#FFE00C', '#FFD564', '#FFC492', '#FFAC64', '#FF7C64', '#9425E6'],
    '#DA4C8E': ['#DA4C8E', '#6B9ED9', '#D2E1F3', '#DCF0C6', '#B9E28D', '#FFEF85', '#FFE00C', '#FFAC64', '#FF7C64', '#D4655F'],
    '#EF9437': ['#EF9437', '#58CFB2', '#9AE2D1', '#B4CEEC', '#6B9ED9', '#FFE00C', '#FFD564', '#FFAC64', '#FF7C64', '#D4655F'],
    '#408D82': ['#408D82', '#8ACF41', '#B9E28D', '#B4CEEC', '#6B9ED9', '#2D76C9', '#FFE00C', '#FFD564', '#FFAC64', '#FF7C64'],
    '#4360AB': ['#4360AB', '#6B9ED9', '#B4CEEC', '#FFEF85', '#FFE00C', '#FFD564', '#FFAC64', '#FFAC64', '#FF7C64', '#9425E6']
}

//进入全屏
const enterFullScreen = (el = document.documentElement) => {
    let rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullscreen;
    if (rfs) {
        // typeof rfs != "undefined" && rfs
        rfs.call(el);
    } else if (typeof window.ActiveXObject !== "undefined") {
        // for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
        let wscript = new ActiveXObject("WScript.Shell"); //eslint-disable-line
        if (wscript != null) {
            wscript.SendKeys("{F11}");
        }
    }
};

// 退出全屏
const exitFullScreen = () => {
    let el = document;
    let cfs =
        el.cancelFullScreen ||
        el.mozCancelFullScreen ||
        el.msExitFullscreen ||
        el.webkitExitFullscreen ||
        el.exitFullscreen;
    if (cfs) {
        // typeof cfs != "undefined" && cfs
        cfs.call(el);
    } else if (typeof window.ActiveXObject !== "undefined") {
        // for IE，这里和fullScreen相同，模拟按下F11键退出全屏
        let wscript = new ActiveXObject("WScript.Shell"); //eslint-disable-line
        if (wscript != null) {
            wscript.SendKeys("{F11}");
        }
    }
};

const competencyList = {
    "计划能力": "Ability\nto plan",
    "组织能力": "Organizational",
    "监控能力": "Monitoring\ncapabilities",
    "领导能力": "leadership",
    "时间管理能力": "Time\nmanagement",
    "团队合作能力": "Ability\nto work\nin a team",
    "交际能力": "Communicative",
    "人际理解能力": "Interpersonal\ncomprehension",
    "影响力": "Influence",
    "洞察能力": "Insight",
    "概念式思维能力": "Conceptual\nthinking",
    "分析式思维能力": "Analytical\nthinking",
    "创新能力": "innovate",
    "学习能力": "learn",
    "成就动机": "Achievement\nmotivation",
    "风险动机": "Risk\nmotives",
    "目标导向性": "Goal-oriented",
    "主动性": "Initiative",
    "责任心": "Responsibility",
    "执行力": "Execution",
    "客户服务导向": "Customer\nservice\noriented",
    "适应性": "adaptability",
    "情绪稳定性": "Emotional\nstability",
    "抗压性": "Stress\nresistance",
    "灵活性": "flexibility",
    "严谨性": "Rigour",
    "果敢性": "Boldness",
    "自信心": "self-assurance",
    "独立性": "independence",
    "自律性": "automaticity",
};

const mentalityList = {
    "躯体化": "Somatization",
    "强迫": "Obsessive-Compulsive",
    "人际关系敏感": "Interpersonal Sensitivity",
    "抑郁": "Depression",
    "焦虑": "Anxiety",
    "敌对": "Anger-Hostility",
    "恐惧": "Phobic-Anxiety",
    "偏执": "Paranoid Ideation",
    "精神病性": "Psychoticism",
};
 const titleList = {
    "分析结果": 'Analysis results',
    "胜任力分析": 'Competency analysis',
    "手部综合检测": "Comprehensive hand testing",
    "心理测验": "Psychological testing",
    "面试记录": "Records",
    "阅读指引": "Reading guide",
    "语音分析": "Speech analysis",
    "社会平均分": "Social average",
    "候选人得分": "subject average",
}

// 记录操作日志到服务端
const actionAndLog = async (msg, callback, level = "info", platform = "PC") => {
    typeof callback === "function" && callback();
    try {
        let _time = new Date();
        console.log(`[${_time.toLocaleTimeString()}:${_time.getMilliseconds()}] [${level}] [AI面试] ${msg}`);
        let _pathname = window.location.pathname;
        let _search = window.location.search;
        let _UA = "，UA：" + window.navigator.userAgent;
        await ajax({
            url: "/sys/addLogs",
            method: "post",
            contentType: "application/json",
            data: {
                level,
                msg: `普通单向 ${platform}端，操作：${msg}，pathname：${_pathname}，search：${_search}${_UA}`
            }
        })
    } catch (err) {
        console.log("actionAndLog error: ", err)
    }
}

export {
    assign,
    unparam,
    ajax,
    ajaxManage,
    initVideoAndJoinChannel as initVideo,
    client as agoraClient,
    AgoraRTC as agoraSDK,
    countTimeDown,
    countNumDown,
    countUp,
    createTimeStr,
    hex2Rgba,
    I18nContext,
    getTokenById,
    setTokenById,
    isValidBrowser,
    chatColor,
    enterFullScreen,
    exitFullScreen,
    competencyList,
    mentalityList,
    titleList,
    actionAndLog,
}
